import React from "react";
import UserCreateContainer from "../../../../Component/Application/Users/selfupdate/CreateNewProjectForm";

const SelfUser = () => {
  return (
    <div className="page-body">
      <UserCreateContainer />
    </div>
  );
};

export default SelfUser;
